import React from 'react';
import Icon from './Icon';

const XCircleIcon = (props) => (
    <Icon {...props}>
        <path
            d="M9 9L15 15M15 9L9 15M22 12A10 10 0 1 1 2 12A10 10 0 1 1 22 12"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </Icon>
);

export default XCircleIcon;
